// extracted by mini-css-extract-plugin
export default {"Emojify":"bbr_a bhs_g"};